import React, { useState } from 'react';

const LoadingSpinner = () => {

  return (
      <div className='spinner-wrapper'>
        <div class="spinner-border" role="status"></div>
      </div>
    );
}

export default LoadingSpinner;




